"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeHtml = void 0;
var _plateCommon = require("@udecode/plate-common");
var _htmlEntities = require("html-entities");
var _elementToHtml = require("./elementToHtml");
var _leafToHtml = require("./leafToHtml");
var _newLinesToHtmlBr = require("./utils/newLinesToHtmlBr");
var _stripSlateDataAttributes = require("./utils/stripSlateDataAttributes");
var _trimWhitespace = require("./utils/trimWhitespace");
/** Convert Slate Nodes into HTML string. */
var _serializeHtml = function serializeHtml(editor, _ref) {
  var _ref$convertNewLinesT = _ref.convertNewLinesToHtmlBr,
    convertNewLinesToHtmlBr = _ref$convertNewLinesT === void 0 ? false : _ref$convertNewLinesT,
    dndWrapper = _ref.dndWrapper,
    nodes = _ref.nodes,
    plateProps = _ref.plateProps,
    preserveClassNames = _ref.preserveClassNames,
    _ref$stripDataAttribu = _ref.stripDataAttributes,
    stripDataAttributes = _ref$stripDataAttribu === void 0 ? true : _ref$stripDataAttribu,
    _ref$stripWhitespace = _ref.stripWhitespace,
    stripWhitespace = _ref$stripWhitespace === void 0 ? true : _ref$stripWhitespace;
  var result = nodes.map(function (node) {
    if ((0, _plateCommon.isText)(node)) {
      var children = (0, _htmlEntities.encode)(node.text);
      return (0, _leafToHtml.leafToHtml)(editor, {
        plateProps: plateProps,
        preserveClassNames: preserveClassNames,
        props: {
          attributes: {
            'data-slate-leaf': true
          },
          children: convertNewLinesToHtmlBr ? (0, _newLinesToHtmlBr.newLinesToHtmlBr)(children) : children,
          editor: editor,
          leaf: node,
          text: node
        }
      });
    }
    return (0, _elementToHtml.elementToHtml)(editor, {
      dndWrapper: dndWrapper,
      plateProps: plateProps,
      preserveClassNames: preserveClassNames,
      props: {
        attributes: {
          'data-slate-node': 'element',
          ref: null
        },
        children: _serializeHtml(editor, {
          convertNewLinesToHtmlBr: convertNewLinesToHtmlBr,
          nodes: node.children,
          preserveClassNames: preserveClassNames,
          stripWhitespace: stripWhitespace
        }),
        editor: editor,
        element: node
      }
    });
  }).join('');
  if (stripWhitespace) {
    result = (0, _trimWhitespace.trimWhitespace)(result);
  }
  if (stripDataAttributes) {
    result = (0, _stripSlateDataAttributes.stripSlateDataAttributes)(result);
  }
  return result;
};
exports.serializeHtml = _serializeHtml;